export function buildTradingPlatformAliasesRowsModel(dtoRows) {
  return dtoRows.map((row) => ({
    platform: String(row.platform || '').trim(),
    platformLabel: String(row.platform || '').trim().toUpperCase() || '-',
    label: String(row.label || '').trim() || '-',
    alias: String(row.alias || '').trim(),
    draftAlias: String(row.draftAlias ?? row.alias ?? '').trim(),
  }));
}

